import { createSelector } from 'reselect'
import { identity, EMPTY_IMMUTABLE_MAP } from '@lacele/const'
import { KeyGenerator, makePath } from '@lacele/utils'

const storeTargetGenerator = new KeyGenerator('heap/')
const storeTargetCache = new Map()

// internal use only
export function generateStoreTarget(obj) {
    // Use an object as key to generate new store targets
    let storeTarget = storeTargetCache.get(obj)
    if (!storeTarget) {
        storeTarget = storeTargetGenerator.getNext()
        storeTargetCache.set(obj, storeTarget)
    }
    return storeTarget
}

export const createTargetSelector = (subTarget) => createSelector(
    identity,
    (storeTarget) => makePath(storeTarget, subTarget)
)

export const createStateSelector = (getTargetFunc, defaultState) => createSelector(
    identity,
    () => getTargetFunc(),
    (state, target) => {
        const value = state.get(target)
        if (value === undefined) {
            if (defaultState !== undefined) {
                return defaultState
            }
            return EMPTY_IMMUTABLE_MAP
        }
        return value
    }
)
